import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { usePublicOfferContext, PublicOfferEditForm } from '../../../../features/public-offer'
import { PUBLIC_OFFER_COMBOS_IDS } from '../../constants'
import { useCombos } from '../../../../features/combos/hooks'
import { PageDisplayer } from '../../../../ui'

export const PublicOfferDetailPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { publicOfferId } = useParams()
  useCombos(PUBLIC_OFFER_COMBOS_IDS)
  const { formatMessage } = useIntl()
  const { detailLoading, detailError, getPublicOffer, publicOffer } = usePublicOfferContext()

  useEffect(() => {
    getPublicOffer(publicOfferId)
  }, [publicOfferId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoBack = () => {
    const prevSearch = location.state?.prevSearch || ''
    navigate('/public-offer' + prevSearch)
  }

  return (
    <PageDisplayer
      maxWidth="md"
      loading={detailLoading}
      handleGoBack={handleGoBack}
      textGoBack={formatMessage({ id: 'pages.campaigns.detail.goBack' })}
    >
      {detailError ? (
        formatMessage({ id: 'pages.campaigns.detail.error' }, { publicOfferId })
      ) : (
        <>
          <Box mb={2}>
            <Typography variant="h4" color="textSecondary">
              {publicOffer['nombre'] || '{Nombre de la campaña}'}
            </Typography>
          </Box>
          <PublicOfferEditForm />
        </>
      )}
    </PageDisplayer>
  )
}
